const actions = {
    START_TRAINING: 'START_TRAINING',
    FINISH_TRAINING: 'FINISH_TRAINING',
    SET_ACTIVE_EXERCISE: 'SET_ACTIVE_EXERCISE',

    FETCH_TRAINING_DATA: 'FETCH_TRAINING_DATA',
    FETCH_TRAINING_DATA_SUCCESS: 'FETCH_TRAINING_DATA_SUCCESS',
    FETCH_TRAINING_DATA_FAIL: 'FETCH_TRAINING_DATA_FAIL',

    OPEN_ACTIVE_TRAINING_DIALOG: 'OPEN_ACTIVE_TRAINING_DIALOG',
    CLOSE_ACTIVE_TRAINING_DIALOG: 'CLOSE_ACTIVE_TRAINING_DIALOG',

    START_EDIT_MODE: 'START_EDIT_MODE',
    ADD_TRAINING_SERIES: 'ADD_TRAINING_SERIES',
    EDIT_TRAINING_SERIES: 'EDIT_TRAINING_SERIES',
    DELETE_TRAINING_SERIES: 'DELETE_TRAINING_SERIES',

    POST_TRAINING_DATA: 'POST_TRAINING_DATA',
    POST_TRAINING_DATA_SUCCESS: 'POST_TRAINING_DATA_SUCCESS',
    POST_TRAINING_DATA_FAIL: 'POST_TRAINING_DATA_FAIL',
}

export default actions